import * as echarts from 'echarts/core';

import { LegendComponent, TooltipComponent } from 'echarts/components';

import EChartsReactCore from 'echarts-for-react/lib/core';
import { Group } from '@mantine/core';
import { PieChart } from 'echarts/charts';
import { SVGRenderer } from 'echarts/renderers';
import { isDark } from '@/utils/utils';
import themeVariables from '@/styles/themeVariables';

echarts.use([SVGRenderer, TooltipComponent, PieChart, LegendComponent]);

const dummyData = [
  { name: '월', value: 38 },
  { name: '화', value: 28 },
  { name: '수', value: 18 },
  { name: '목', value: 38 },
  { name: '금', value: 28 },
  { name: '토', value: 68 },
  { name: '일', value: 48 },
];

const DonutChart = ({ data }) => {
  const { dark } = isDark();

  return (
    <Group
      sx={{
        justifyContent: 'center',
        width: '100%',
        '> .echarts-for-react': { width: '100%' },
      }}
    >
      <EChartsReactCore
        echarts={echarts}
        opts={{ renderer: 'svg', height: 'auto' }}
        option={{
          tooltip: {
            trigger: 'item',
          },
          legend: {
            orient: 'horizontal',
            bottom: 'bottom',
            textStyle: {
              color: themeVariables.darkMode.normal(dark),
            },
          },
          series: [
            {
              type: 'pie',
              radius: '50%',
              data: data || dummyData,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)',
                },
              },
              label: {
                color: themeVariables.darkMode.normal(dark),
              },
            },
          ],
        }}
      />
    </Group>
  );
};

export default DonutChart;
